import Factory from '@/modules/Factory'

/**
 * @class 
 * @extends Factory
 * @description Factory Device Manager module 
*/
export default class DeviceManagerFactory extends Factory{

    /**
     * @static
     * @override 
     * @method create Instance a concrete object based on cloud provider selected
     * @param {String} provider Backend provider 
     * @param {Object} settings Module settings custom for backend provider selected
     */
    static create(provider,context,settings){
        let Provider = null
        let moduleInstance = null
        switch(provider){
            case "aws":
                Provider = require("./implementations/AWS").default
                moduleInstance = new Provider(context,settings)
                break
            default: 
                throw "No provider '"+provider+"' available" 
        }
        return moduleInstance
    }
}